module.exports = __webpack_public_path__ + "img/5.58b6a37.png";